<td [ngClass]="width" class="bold" [ngClass]="{'padding-top-12 padding-bottom-12': !fc}">{{ label }}</td>
<td *ngIf="!fc" class="bold">:</td>
<td *ngIf="!fc" class="bold">{{ value }}</td>
<td *ngIf="fc">
    <div class="input-group input-group-sm">
        <mat-form-field appearance="outline">
            <input *ngIf="inputType === 'text' || inputType === 'number'" matInput [type]="inputType" [formControl]="fc"
                autocomplete="off" [name]="fieldName" ngDefaultControl [readonly]="isReadonly" />

            <mat-select *ngIf="inputType === 'select'" [formControl]="fc" ngDefaultControl>
                <mat-option *ngFor="let item of options" [value]="item.id">
                    {{ displayOption(item) }}
                </mat-option>
            </mat-select>

            <input *ngIf="inputType === 'date'" matInput [matDatepicker]="datePicker" autocomplete="off"
                [formControl]="fc" [name]="fieldName" ngDefaultControl />
            <mat-datepicker-toggle *ngIf="inputType === 'date'" matSuffix [for]="datePicker">
                <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
            <mat-error *ngIf="fc.invalid">{{ getErrorMessage(fc) }}</mat-error>
        </mat-form-field>
    </div>
</td>